module.exports = __webpack_public_path__ + "static/media/intiva_logo.ef51ca47.svg";